function getSrc(el) {
  return el.attr('src') ? el.attr('src') : el.attr('data-src');
}

function getAlt(el) {
  return el.attr('alt') ? el.attr('alt') : null;
}

export default function createHeroBanner() {
  const $heroContent = $('.content .rowIndex-1');
  const $heroImage = $heroContent.find('.ImageModule .imageModule-single img');

  if ($heroImage.length > 0) {
    $('body').addClass('has-banner');
    const heroImageSrc = getSrc($heroImage);
    const heroImageAlt = getAlt($heroImage) ? getAlt($heroImage) : 'San Antonio Stock Show Rodeo';

    const bannerStructure = `
      <div class="subpage-banner">
        <img src="${heroImageSrc}" data-src="${heroImageSrc}" alt="${heroImageAlt}" class="lozad"/>
        <span class="hero-divider"></span>
      </div>
    `;

    $(bannerStructure).insertBefore('.content');

    $heroContent.hide();
  }
}
